module.exports = __webpack_public_path__ + "img/YARLUNG新观察.350fb37f.png";